function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { FormattedMessage } from 'react-intl';
import cn from 'classnames';
import Button from 'components/Form/Button';
import FiltersIcon from 'svg/filters.svg';
import messages from '../../messages';
import styles from './NotificationsPopover.pcss';
const FiltersButton = ({ onClick, isActive })=>/*#__PURE__*/ _jsxs(Button, {
        id: "notifications-filters-btn",
        className: cn(styles.notifications__filtersBtn, 'btn--filled', {
            [styles['notifications__filtersBtn--active']]: isActive
        }),
        styleModifier: isActive ? 'primary' : 'transparent',
        onClick: onClick,
        children: [
            /*#__PURE__*/ _jsx(FiltersIcon, {}),
            /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.buttons.filter))
        ]
    });
export default FiltersButton;
